export const MAXIMUM_NUMBER_OF_BUILDS = 30;
export const BAR_HEIGHT_MINIMUM = 3;
export const BAR_WIDTH = 7;
export const BAR_SEPARATOR_WIDTH = 1;
export const BAR_WIDTH_WITH_SEPARATOR = BAR_WIDTH + BAR_SEPARATOR_WIDTH;
export const GRAPH_HEIGHT = 30;
export const GRAPH_WIDTH =
  BAR_WIDTH * MAXIMUM_NUMBER_OF_BUILDS + (MAXIMUM_NUMBER_OF_BUILDS * BAR_SEPARATOR_WIDTH - 1);
